import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const selectCustomersListState = (state: RootState) => state.customersList;

export const selectCustomersListRows = createSelector(
  [selectCustomersListState],
  (state) => state.rows,
);

export const selectCustomersListLoading = createSelector(
  [selectCustomersListState],
  (state) => state.loading,
);

export const selectCustomersListError = createSelector(
  [selectCustomersListState],
  (state) => state.error,
);

export const selectCustomersListSortOrder = createSelector(
  [selectCustomersListState],
  (state) => state.sortingOrder,
);

export const selectCustomersListSortField = createSelector(
  [selectCustomersListState],
  (state) => state.sortingField,
);

export const selectCustomersListLocationFilterIds = createSelector(
  [selectCustomersListState],
  (state) => state.locationFilterIds,
);

export const selectCustomersListFilterStatus = createSelector(
  [selectCustomersListState],
  (state) => state.listFilterStatus,
);

export const selectCustomersListDeleteSubmitting = createSelector(
  [selectCustomersListState],
  (state) => state.deleteSubmitting,
);

export const selectCustomersListDeleteError = createSelector(
  [selectCustomersListState],
  (state) => state.deleteError,
);

export const selectCustomersListFormSubmitting = createSelector(
  [selectCustomersListState],
  (state) => state.formSubmitting,
);

export const selectCustomersListEditPrefillLoading = createSelector(
  [selectCustomersListState],
  (state) => state.editPrefillLoading,
);

export const selectCustomersListShowOnlyActive = createSelector(
  [selectCustomersListState],
  (state) => state.showOnlyActive,
);

export const selectCustomersListOperatorFilterIds = createSelector(
  [selectCustomersListState],
  (state) => state.operatorFilterIds,
);

export const selectCustomersListTotal = createSelector(
  [selectCustomersListState],
  (state) => state.totalCustomers,
);

export const selectCustomersListSearch = createSelector(
  [selectCustomersListState],
  (state) => state.search,
);

export const selectCustomersListFromIndex = createSelector(
  [selectCustomersListState],
  (state) => state.fromIndex,
);

export const selectCustomersListToIndex = createSelector(
  [selectCustomersListState],
  (state) => state.toIndex,
);
